import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = { id_estoque_local: 2 }) {
    return {
        type: 'EMBALAGEM_INVENTARIO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = { id_estoque_local: 2 }) {
    return [
        initialize('embalagemInventarioForm', registro)
    ];
}

export function setFiltro(filtro = {}) {
    return {
        type: 'EMBALAGEM_INVENTARIO_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function getLista() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/embalagemInventario?id_cliente=${getState().auth.usuario.id_cliente || 0}
			&data_inicial=${DateFormat.formatarDataTelaParaSql(getState().embalagemInventario.filtro.data_inicial) == 'Invalid DateTime' ? null : DateFormat.formatarDataTelaParaSql(getState().embalagemInventario.filtro.data_inicial)}
			&data_final=${DateFormat.formatarDataTelaParaSql(getState().embalagemInventario.filtro.data_final) == 'Invalid DateTime' ? null : DateFormat.formatarDataTelaParaSql(getState().embalagemInventario.filtro.data_final)}`)
		.then(resp => {
			dispatch({
		        type: 'EMBALAGEM_INVENTARIO_LISTADO',
		        payload: resp
			});
		}).catch(e => {
			console.log(e);
			
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/embalagemInventario`, {
				...registro,
				id_cliente: getState().auth.usuario.id_cliente,
				id_usuario_alteracao: getState().auth.usuario.id,
				datahora_previsao: registro.datahora_previsao ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_previsao) : null,
				datahora_inventario: registro.datahora_inventario ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_inventario) : null
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/embalagemInventario`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id,
				datahora_previsao: registro.datahora_previsao ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_previsao) : null,
				datahora_inventario: registro.datahora_inventario ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_inventario) : null
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/embalagemInventario?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaFornecedor() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/fornecedor/listarSelect?id_cliente=${getState().auth.usuario.id_cliente || 0}`)
		.then(resp => {
			dispatch({
				type: 'EMBALAGEM_INVENTARIO_FORNECEDOR_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaEstoqueLocal() {
    const request = axios.get(`${consts.API_URL}/estoqueLocal/listarSelect`);
    return {
        type: 'EMBALAGEM_INVENTARIO_ESTOQUE_LOCAL_SELECT_LISTADO',
        payload: request
    };
}
